import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var WalkIcon =
/*#__PURE__*/
// eslint-disable-next-line react/forbid-elements
_jsx("svg", {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.42 2.75a1.75 1.75 0 0 1-2.313 1.657l.408.245 2.341 1.405 1.759-.88.894 1.79-2.25 1.125-.49.245-.471-.282L8.64 7.06l-1.92 7.69-1.94-.484 1.613-6.461.763-2.972.357-.198.485-.27a1.75 1.75 0 1 1 2.42-1.616ZM5.927 5.517l-3.475 1.93.972 1.75 1.817-1.01.686-2.67Zm2.532 6.104-.033-.048.67-2.552 1.066 1.546.055.08.039.09 1.457 3.376-1.836.792-1.418-3.284Z",
    fill: "currentColor"
  })
});